<template>
  <div class="prose patricia-container">
    <!-- Intro with animation -->
    <div
      class="intro-section noMarginBottom column alignCentreColumn animate fadeInUp"
    >
      <p class="intro-text serif smaller-text text-center largerLetterSpacing">
        THIS IS THE TURNING OF THE PAGE
      </p>
      <div>
        <h1
          class="text-center largest-TextMag largeLetterSpacing patricia-main-title"
        >
          PATRICIA
        </h1>
        <p class="text-center subtitle-text noMarginTop">& her alter egos</p>
      </div>
      <p class="text-center italic shortWdithOnDesktop serif noMarginBottom">
        The second act and character that will break all the rules and open up
        worlds of possibilities.
      </p>
    </div>

    <!-- Portrait Image - Single image with opacity -->
    <div class="row alignCentreRow headerImgText">
      <div class="portrait-image-container animate floating">
        <img
          class="patriciaTealImage"
          :src="patriciaTealImage"
          alt="Patricia"
          style="opacity: 0.6"
        />
      </div>

      <div class="headerQuote row fullWidth alignCentreRow alignTopRow">
        <div class="fromPatricia animate fadeInRight">
          <h2>I feel a thousand men</h2>
        </div>

        <div class="toAlterEgos animate fadeInRight">
          <h2>and a thousand women in me</h2>
        </div>
        <div class="untold animate fadeInRight">
          <h2>
            their stories <span class="serif teal"> untold</span>
          </h2>
        </div>
      </div>
    </div>

    <!-- Character Page Micro-NDA -->
    <MicroNDA variant="deeper" />

    <!-- Collections with staggered animation -->
    <div
      class="hugeMarginTop bigMarginBottom collections-section animate fadeInUp"
    >
      <h3 class="text-center">The 4 Collections</h3>
      <p class="fullWidth text-center italic grey-dark">2029-2030</p>

      <SwissStyleTable
        :headers="['Collection & Project', 'Type', 'Status']"
        :rows="[
          [
            ['THE MOUNTAIN', 'Spring'],
            'Feature Film',
            { color: 'var(--grey)', text: 'Written' },
          ],
          [
            ['MAN SHALL NEVER KNOW ANY OF THIS', 'Summer'],
            'TV Series',
            'Written',
          ],
          [
            ['ECHO', 'Fall'],
            'Feature Film Mockumentary',
            { color: 'var(--grey)', text: 'In development' },
          ],
          [
            ['WHAT TAKES SHAPE IN THE MIDDLE OF NOWHERE', 'Winter'],
            'Feature Film',
            'Written',
          ],
        ]"
        :statusColumnIndex="2"
        :emphasizeColumnIndex="0"
        class="noMarginBottom"
      />
      <div class="smallMarginTopBigMarginBottom">
        <small class="text-center small-text italic grey-dark">
          Patricia prefers to channel stories through a literary medium before
          adapting them to scripts so all stories marked as written were either
          developed in a novel or novella format and will feature in the list of
          artefacts launched per collection. Scripts will be or are already
          developed from those original stories. All stories marked as in
          development are in a concept stage with the narrative arch delineated,
          just waiting for the right time to be channeled into a full
          novella/script, depending on each story's requirements.
        </small>
        <!-- <small class="text-center small-text italic grey-dark">
          Stories marked written originated as novels/novellas; those marked in
          development are at concept stage awaiting full adaptation.
        </small> -->
      </div>
    </div>

    <!-- About Patricia with side illustration on desktop -->
    <div class="about-section">
      <h2 class="animate fadeInLeft bold about-patricia-title">
        About Patricia
      </h2>
      <div class="about-content">
        <div class="about-text">
          <p class="animate fadeInUp">
            Patricia is the second manifestation of this spark of consciousness.
            If Cecilia desired to be born anew as a human and forget, Patricia
            seeks to remember what she ended up forgetting by becoming human.
            The two are not in dissonance because if Cecilia knew what was like
            to be a work of art then Patricia knows what is like to be an artist
            who creates works of art.
          </p>
          <p class="animate fadeInUp delay-1">
            Patricia moves to the beat of her own drum, trusts her inner voice
            no matter the consequences and follows through with flashes of pure
            knowing that dictate the way. Her disruptive nature is a way to seed
            the future onto the present and challenge the status quo. Moving
            from exploration to discovery, her role is to seed higher
            consciousness into form and even if Patricia is not entirely aware
            of her mission as the journey starts, the evolution of her story
            will bring back what she needs in order to remember and align with
            this higher path. She is the glitch in the matrix, a human who lives
            in the world through her innate humanity but that seems to possess
            something dormant in her that guides her through the pulse of her
            creativity to a mission higher than what she is yet able to
            comprehend. As an author, she knows there is something only she can
            do and that is her gift to the world, and after having devoted the
            first years of her life to finding what that is, her story redirects
            her to leave her hometown behind and undertake a journey to a
            mysterious site where her first novel was set, unveiling a deeper
            journey through time and space that seems to link different stories
            and ladders of creation directly to the mystery of her gnosis.
          </p>
          <p class="animate fadeInUp delay-2">
            She has an innate gift to put her unique perspective translated into
            stories and, as profoundly embedded with her creations as she is,
            her hunger for freedom and authenticity will take her on a fast
            track to ascension, making her eager to live a romantic passionate
            life where the heart never closes and always dictates the way. Ready
            to wear as many costumes as necessary in order to personify her
            shapeshifter nature, Patricia will fragment onto different alter
            egos, in order to explore different facets of her nature. Her
            openness to experiment, explore, confront obstacles, solve
            challenges and adapt ignites a process of fragmentation where her
            various alter egos – the rebellious parts of her psyche that seek to
            unify by individualizing first – guide her towards universalization.
            Each of her characters being like a piece in a chess game, bringing
            her closer to checkmate. These alter egos and characters are more
            than fictionalized creations, demanding love and surrender for the
            stories they are here to tell from beginning to end, appearing
            almost as entities that want to be channeled in order to deliver
            messages and guide their creator back to the bigger truth guiding
            her life story. Every time the alter ego learns and evolves, the
            artist does too and a level of mastery is accomplished, opening up
            the way for the next round of ascension.
          </p>
          <p class="animate fadeInUp delay-3">
            We interact with Patricia as if we are finding a force of awakening,
            change and insight that inevitably changes us. Her eccentric nature
            is here to challenge her own sense of identity and others', allowing
            her to evolve into her complexity and inner genius. She is
            recognized by her excentric style echoing the rebellion that ended
            Cecilia's existence and that allows her a way out from the
            establishment towards her unique truth. She is a force of nature and
            nature moves with her making her a force of unpredictability for
            others. Her unconventionality makes her also subject to projection
            from other people however Patricia is quite aware of the projections
            and use them in a way to fragment and expand even deeply towards her
            artistry and truth, role-playing her character in and out of her
            creations towards true freedom. As the sphere of her influence
            changes and turns global, Patricia starts becoming more aware of how
            she can use those projections for a collective awakening,
            illuminating the way for others by going first. Patricia knows how
            to surrender to the electrical currents and allow lightning and
            thunder to strike, paving a way that will clear the road to
            unforeseen possibilities.
          </p>
          <p class="animate fadeInUp delay-4">
            Society is looking in and she is looking back, speaking to the
            collective and transferring universal truths in the work she
            produces. Even though all breakthroughs happen at an individual
            level, they are universalized and shared outwards, influencing those
            around and eventually society as a whole. It is this awareness of
            the stream of polarities on earth and the fierceness and
            vulnerability in fragmenting through them as much as needed in order
            to expand that will allow her to ascend and evolve into our brand's
            eponymous, The Path.
          </p>

          <img
            :src="images[6]"
            alt="Patricia Image 7"
            class="animate fadeInRight delay-6"
          />
        </div>
        <div class="about-images">
          <img
            :src="images[0]"
            alt="Patricia Image 1"
            class="animate fadeInRight"
          />
          <img
            :src="images[1]"
            alt="Patricia Image 2"
            class="animate fadeInRight delay-1"
          />
          <img
            :src="images[2]"
            alt="Patricia Image 3"
            class="animate fadeInRight delay-2"
          />
          <img
            :src="images[3]"
            alt="Patricia Image 4"
            class="animate fadeInRight delay-3"
          />
          <img
            :src="images[4]"
            alt="Patricia Image 5"
            class="animate fadeInRight delay-4"
          />
          <img
            :src="images[5]"
            alt="Patricia Image 6"
            class="animate fadeInRight delay-5"
          />

          <p class="animate fadeInUp delay-1">
            Patricia will be represented by the present, a present that is both
            intemporal and still visually nostalgic in its aesthetics. We meet
            Patricia in the present but we also quantum jump with her into and
            through the fictionalized universes of her creation where she
            embodies one of her characters, navigating the worlds of her novels
            that exist through time and space with a unique atmosphere of their
            own.
          </p>
        </div>
      </div>
    </div>

    <!-- Stories with alternating layouts -->
    <div class="largestMarginTop stories-section">
      <h2 class="largestMarginTop text-center animate fadeInUp">
        The 4 Stories
      </h2>
      <p class="text-center animate fadeInUp">
        Patricia's hypnotic presence will be palpable through the aesthetics
        surrounding her 4 main films, each of their corresponding collections
        evolving through the aesthetics of the 70's, 80's, 90's and the current
        21st century audiovisual style. This time, the audience observes
        Patricia and Patricia observes the audience back, making the screen a
        window of interaction and mutual evolution.
      </p>

      <!-- Story 1 with right-aligned images on desktop -->
      <div class="film-title-container">
        <div class="circleNumber">1</div>
        <img
          src="@/assets/images/Patricia/images/titles/the-mountain.png"
          alt="The Mountain"
          class="film-title film-title-mountain animate fadeInDown"
        />
      </div>
      <section
        class="story-section story-right animate fadeIn"
        data-theme-group="patricia"
      >
        <div class="story-content">
          <p class="animate fadeInLeft delay-1">
            The first collection is based on the feature film "The Mountain".
            Patricia arrives at the city of Mount Shasta, as an author on a
            quest for illumination, seeking out the mountain's call to rewrite
            her already published novel and awaken to a forgotten story that
            apparently is not only hers. Back in Portugal she was known for her
            book "Man Shall Never Know Any Of This" that featured the mountain
            as the iconic background of a story that surpassed different
            timelines and parallel realities. In the years following her debut
            as an author, she went through a lifechanging awakening that shaped
            her both as a woman and an artist, putting her previous novel and
            the mountain as a recurring mystery that demanded to be
            deciphered.Feeling like it is time to go back as she moves forward,
            Patricia travels to the city of Mount Shasta for a short stay that
            will hopefully clarify what lies veiled in her creative work.
          </p>
          <p class="animate fadeInLeft delay-1">
            As she crosses continents, she is followed by the inner vision and
            presence of a man that not only seems to accompany her every time
            she levels up but that also holds the mystery of the new manuscript
            she has been secretly working on for 10 years. As soon as she
            arrives at the city, she meets David, the police chief of command,
            that take her around for an informal visit to the city’s center. As
            they walk, Patricia stops at the entrance of a closed shop that
            belongs to a deceased actor that passed away from an overdose around
            30 years ago. Moved by an uncanny emotion of loss and passion, she
            tries to grasp the shop’s interior only to find it disturbingly
            familiar. As their walk continues, they meet Rose, who David
            presents to Patricia and that rents her a house for her stay. Later
            on, Patricia crosses paths with Mia, a mystical tour guide, that
            seems enigmatically attractive and that allures her with prophecies
            about the short coming Carnival that seems to be one of Mount
            Shasta’s most celebrated holidays of the year. Intrigued by those
            and other peculiar characters the city seems to host, Patricia
            decides to prolong her stay for longer than expected, certain that
            the city will inform her creative process and serve as a doorway for
            her two books.
          </p>
          <p class="animate fadeInLeft delay-1">
            As the days pass, she starts rewriting what is to be her updated
            novel and the second mysterious manuscript she has been working on
            for 10 years under the atmospheric mountain setting, in the company
            of that town’s strange characters that start giving her plots
            definition. Eventually, she starts waking up at 5am the sound of a
            coyote that no one else around seems to notice and that howls
            specifically for her. Strange occurrences start pulling her to a
            valley on the woods next to her place where time seems to pass in a
            different way. Building on the momentum of those incidents, the
            night before the Carnival, Patricia meets Mia for a tea at her place
            and while they taste the hypnotic elixirs that Mia makes from local
            plants and trees, Patricia finds a mysterious ancient book on Mount
            Shasta’s legends about a lost civilization and city that lie at the
            base of the mountain. Forgotten memories start coming online and
            while the city rumbles in the first hours of the Carnival
            celebration that will last for three days and where everyone comes
            out masked, Patricia feels irresistibly pushed to the forest,
            leaving the city behind and colliding with what seems to be a time
            tunnel that connects her with the man she kept envisioning.
          </p>
          <p class="animate fadeInLeft delay-1">
            The next day, she awakens into an alternate reality where the same
            characters inhabit the city but certain events and locations have
            changed. While taking a walk in the center, Patricia encounters the
            people she has previously met, to discover that the previous version
            of reality she knew no longer exists. Awake in this alternate
            timeline where changes seem at first subtle or circumstantial,
            Patricia escapes the chaos created by the Carnival marches and
            celebrations and as she takes the less traveled road back to the
            city’s suburbs, she passes by the closed shop she found upon her
            first day in town to find it open with a man moving boxes from
            within it. As she sits down to catch her breath, the man looks at
            her and aware that this is the same mysterious figure that
            accompanied her and that made her start her unpublished manuscript,
            she realizes he is also an older version of the deceased actor who
            seems to be very well aware of who she is and why they are both
            there at that time.
          </p>
          <p class="animate fadeInLeft delay-1">
            As they spend the next week together, visiting the mountain’s base
            and other nearby natural sightings, Patricia starts untangling the
            pieces of the puzzle of who that man is and why they seem so
            profoundly connected to each other. As they stumble across this
            alternate universe together, Patricia finds out the shop has never
            closed or even open to the public in this reality, bust instead
            worked as a sort of personal museum where a collection of artefacts
            hid an ancient mystery that transcended time and space or even
            reality as humanity knows it.
          </p>
          <p class="animate fadeInLeft delay-1">
            During the last week they spend together in Mount Shasta, a powerful
            insight comes through that guide Patricia to write an additional
            chapter to her already published “Man Shall Never Know Any of This”,
            completing the story she channeled years prior and finding their way
            out for of the time loop the mysterious man seem to have been stuck
            into. As their time together helps them grow in intimacy and a
            metaphysical process that increases the deeper they get, a third
            presence starts making itself known between the lovers, providing a
            hint on a riddle yet to crack of what could be the unexpected
            presence of a third member yet to be revealed, someone who doesn’t
            seem to have been born yet but that somehow found a way to travel
            back to find them. Realizing the power of her writing and the
            inherent unrealized spiritual gifts, Patricia create the words that
            bend reality, pulling that unborn man closer and closer and the last
            lines of her new manuscript “What Takes Shape in The Middle of
            Nowhere” together. Hint by hint, the jigsaw starts falling into
            place, and the lovers find themselves at a crossroad, where they
            must choose between the old life they were both living or depart on
            an adventure together that will change their lives and the world,
            allowing them to share the unique story they seem to be entrust
            with. As they decide to leave Mount Shasta together and follow the
            road home, a rare treasure is unburied, echoing a frequency between
            them that seeks to give the unborn a voice so the impossible can be
            done.
          </p>
          <p class="animate fadeInLeft delay-1">
            The photography of this film will be somehow intemporal, following
            current aesthetics embedded with a slight nostalgic feeling that
            still evokes the 90’s, as if 1993 is just around the corner, since
            the timeline split will inevitably take us back there. Even though
            this is a spring collection/film, the photography will help recreate
            a wintery feeling throughout most of the narrative with an opening
            in terms of light and warmer colors more towards the second and
            third acts of the story. A lot of key scenes will take place during
            the blue hour so blues, purples, pinks will be prevalent,
            illustrating the liminal space the protagonist is inhabiting. In
            terms of sound, after Cecilia’s performance and sacrifice,
            Patricia’s clairaudience will gradually improve as her seasons and
            collections evolve. This film will be highly atmospheric in terms of
            sound, making use of nature’s sounds, subtle focus on wind, birds,
            crickets and, of course, the coyote which will play a significant
            role throughout this narrative, often giving an eerie acoustic note
            that enhance the tension but bring the protagonists’ awareness back
            to the natural world and away from artificial frequencies. The whole
            film takes place in the small town of Mount Shasta so there’ll be a
            constant presence of nature’s ambience sounds and the mountain who
            appears and sounds as a living entity whose frequency is palpable.
            This mixture of silence and nature’s symphonies will help ground the
            audience in Mount Shasta’s setting and reinforce the immersion the
            protagonist is also experiencing with the earth’s magnetic pole. At
            the same time, in order to recreate any interdimensional
            channelings, downloads or changes in frequency or consciousness that
            the protagonist is experiencing, sounds will be used with an
            intentional dramatic impact, allowing us to feel the sensory
            immersion of those experiences without necessarily having to see
            anything on the canvas of her reality.
          </p>
          <div class="film-details animate fadeInLeft delay-2">
            <div class="detail-section">
              <h4>Keywords</h4>
              <p>
                <span>atmospheric</span>
                <span>mysterious</span>
                <span>investigative</span>
                <span>enigmatic</span>
                <span>dreamy</span>
                <span>mind bending</span>
                <span>suspenseful</span>
                <span>psychological</span>
                <span>philosophical</span>
                <span>thought provoking</span>
                <span>melancholic</span>
              </p>
            </div>
            <div class="detail-section">
              <h4>Themes</h4>
              <p>
                Small town, mountain, author, memory, changing the past,
                parallel universe, destiny, alternate reality, interdimensional
                travel, alternate timeline, timeline split, self-discovery
                journey, love of one's life, mountain setting, investigation,
                mysterious place, hidden information, metaphysics, ancestral
                enigma, supernatural romance, magical realism, lost love,
                lifestyle change, time paradox, choice, love story, true love,
                obsessive quest, against odds, fate, destined lovers.
              </p>
            </div>

            <div class="detail-section">
              <h4>Visual Style</h4>
              <p>
                Cool tones with strong contrast growing into progressive warm
                bright and fresh tones (symbolizing the coming out of deep
                winter into spring). The whole film will have cool undertones,
                providing a dreamy immersive feeling, where blues, purples and
                pinks are predominant when associated with the mountain
                landscape and Patricia's immersive creative processes.
              </p>
            </div>

            <div class="detail-section">
              <h4>Visual References</h4>
              <p>
                Cold Mountain, Burning 2018, The Revenant, Barry Lindon (visual,
                color grading, environment) Twin Peaks TV Series ½, Fargo, The
                Last Picture Show, Three Billboards Outside Ebbing Missouri,
                What's Eating Gilbert Grape (small town ambience and set)
              </p>
            </div>
          </div>
        </div>
        <div class="story-images">
          <div class="film1-gallery">
            <img
              v-for="(img, index) in film1Images"
              :key="index"
              :src="img"
              :alt="`The Mountain Scene ${index + 1}`"
              class="animate zoomIn"
            />
          </div>
        </div>
        <div class="film-quote-container">
          <div class="film-quote film-quote-mountain animate fadeIn delay-1">
            Important things take time coming back from dreams
          </div>
        </div>
      </section>

      <!-- Story 2 with left-aligned images on desktop -->
      <div class="film-title-container">
        <div class="circleNumber">2</div>
        <img
          src="@/assets/images/Patricia/images/titles/man_2.png"
          alt="The Mountain"
          class="film-title film-title-man animate fadeInDown"
        />
      </div>
      <section
        class="story-section story-left animate fadeIn"
        data-theme-group="patricia"
      >
        <div class="story-content">
          <p class="animate fadeInRight delay-1">
            In the second collection we are taken inside the universe of
            Patricia's first novel and her alter ego Barbara. The narrative arch
            of this 13-episode-tv series follows that of Patricia's first novel
            Man Shall Never Know Any Of This with a new exclusive fragment added
            to the story that allow us inside what was impenetrable before.
          </p>

          <p class="animate fadeInRight delay-1">
            Spring of 1969: Ian is a musician cultured in occultism and Led
            Zeppelin whose band Ouranos just got off the ground. Fueled by the
            intoxicating madness following the breakup with his enigmatic
            girlfriend Sheila and the desire for creative freedom, he leads a
            routine of immersive self-destructive compulsions and transfixations
            until the spinners of destiny and their deceitful business propel
            him towards Jeannette on a night near the winter solstice. Jeannette
            is a timid dreamer fascinated by dead languages and mysteries that
            just enrolled a Latin graduation program. After a night of
            misaligned expectations, with Ian ruminating over his sultry ex and
            Jeannette fantasizing about a swirling romance between the two of
            them, they end up sleeping together and Jeannette gets pregnant. Set
            in the California’s coast, the story of these two families coming
            together is told retrospectively, from 2060 to 1969, through the
            voice of the twelve sons and daughters that could have been the
            result of this fertilization. The destiny of this story is ignited
            by the fixation of the embryo and its varied potentiality of people
            and perspectives that take us through tunnels of secrets and hidden
            chambers to the broader revelation underlying this story’s purpose.
          </p>

          <p class="animate fadeInRight delay-1">
            Each chapter is set in a different time, with a character living a
            different story, bearer of a unique distinguishable voice, with also
            a contrary and sometimes conflicting proximity with different
            members of the family but always leading back to the beginning and
            their parents perspective the night they met. Each narrator is only
            accessible in a glimpse of time, a micro piece of a macro narrative,
            allowing us in their ephemeral universe just long enough for the
            fixed characters in this narrative to be known and the truth of
            their story to be told inside the multidimensionality that connects
            them. Just like Jeannette tells us endlessly, terminus pendeo in
            exordium, the end depends or lies in the beginning, which means it
            shall take us different stories to get to know one. Time is thus the
            greatest storyteller here, weaving its web through the evolution of
            the unit of consciousness that take us on a multifaceted journey
            expressed in the polarity of the various people that compose it.
            Mount Shasta also emerges as a vital symbol throughout this
            narrative, where the seed of a deeper story lies, emerging through
            the author in it Barbara – Ian and his ex Sheila’s illegitimate
            daughter and Patricia’s alter ego - the mysterious key that exists
            in a story that is not only hers, taking almost backstage in a
            narrative full of plots, complexity, unfulfilling relationships and
            fated events that inevitability make the direct link between the
            artist and the work of art.
          </p>
          <p class="animate fadeInRight delay-1">
            Over the course of 100 years, this 13 episode story will be narrated
            in non-linear time, starting in the present day when Patricia is
            finishing updating her novel for the launching of the eponymous tv
            series. As she merges with her character and alter ego, we dive into
            the fictionalized world, directly to the winter season of 1969 where
            Ian and Jeannette meet and she gets pregnant. From there on, the
            story is told retrospectively from 2060 to 1971, where the unique
            perspectives of the 11 possible sons and daughters move us through
            this unique family story. The 13th and last episode features an
            additional chapter to the original novel, a lost piece of the story,
            that allows us into the time loop that united Patricia and the
            mysterious man from the last collection.
          </p>
          <p class="animate fadeInRight delay-1">
            Visually, this tv series will feature different aesthetics relating
            to the era from where the character is narrating from. We will cross
            times and narrative styles moving from 2060 to 1969, with the
            respective visual esthetics of the 70’s, 80’s, 90’s and 21st century
            films in focus, creating each episode’s inherent reality as an
            extension of the narrator’s inner world starring in it. In terms of
            sound, music is highly influential throughout the protagonists inner
            worlds and the context surrounding this story. Following the novel’s
            title page [this book should be played loud] that was inspired by
            the concert documentary “The Last Waltz”, directed by Martin
            Scorsese, this tv series intro will open with the title card “this
            story should be told loud” honoring the influence that music and
            sound have throughout the narrative. Music appears to give a clear
            indicator that this series will take us through a soundtrack that
            marks an eon in the story of humanity from the end of the flower
            power movement to the unforeseen future, offering us the original
            album of Ian’s band fictionalized Ouranos. As we are moving into a
            highly acoustic era in the story of humanity, both the soundtrack
            and the acoustic experience throughout the series will be immersive
            and impactful. Songs appear as a way of merging with the characters
            musical influences, as a mark of the years hits and cultural
            movements or as musical treats, giving us a little bit more into the
            character’s universe or mindset, functioning as a way to deepen the
            symbolism inherent in the scene. Fundamentally, the musicality of
            this tv series will take the spectator on a journey of auditory
            expansion both through sound frequencies as well as commercial music
            that gives us a tone for the external and internal environments.
          </p>

          <div class="film-details animate fadeInRight delay-2">
            <div class="detail-section">
              <h4>Keywords</h4>
              <p>
                <span>surreal</span>
                <span>witty</span>
                <span>utopian</span>
                <span>insightful</span>
                <span>imaginative</span>
                <span>thought provoking</span>
                <span>evocative</span>
                <span>character-driven</span>
                <span>fascinating</span>
                <span>graphic</span>
                <span>stylized</span>
                <span>fast paced</span>
                <span>offbeat</span>
                <span>unusual plot structure</span>
                <span>mind bending</span>
                <span>suspense</span>
                <span>dramatic</span>
                <span>entertaining</span>
                <span>captivating</span>
              </p>
            </div>

            <div class="detail-section">
              <h4>Themes</h4>
              <p>
                Non-linear time, multiple outcomes, reverse motion, parallel
                realities, multiple storylines, reverse chronology, time, music,
                occultism, based on a novel, Los Angeles, California, family
                relationships, passage of time, inevitability, fate, identity,
                ambition, music industry, relationships, twists and turns,
                choice, meaning of life, self-discovery, uncover truth,
                butterfly effect, synchronicities.
              </p>
            </div>

            <div class="detail-section">
              <p>
                This tv series includes a wider collection of visual styles &
                aesthetics, depending on the nature and tone of the episode.
                Notes on visual references and similar films will be indicated
                by episode. Overall, since this is a summer collection, colors
                will be vibrant and impactful throughout this tv series. Some
                general film references can be Licorice Pizza (2021), Boogie
                Nights (1997), Dazed and Confused (1993), Fear and Loathing in
                Las Vegas (1998), American Graffiti (1973), Inherent Vice
                (2014).
              </p>
            </div>
          </div>
        </div>
        <div class="story-images">
          <div class="film2-gallery">
            <img
              v-for="(img, index) in film2Images"
              :key="index"
              :src="img"
              :alt="`Man Shall Never Know Scene ${index + 1}`"
              class="animate zoomIn"
            />
          </div>
        </div>
      </section>

      <h3 class="bigText the13Episodes">The 13 Episodes</h3>
      <p class="the13EdisodesParagraph text-center animate fadeInUp">
        Following the ending on the last collection's film, each episode will
        open with a metaphorical door that will grant us access to a parallel
        timeline, understanding the resonance and interactivity between all the
        alternate realities, until we converge back in the timeline where our
        transmission is being broadcasted from.
      </p>
      <div :class="{ 'border-bottom': !showEpisodes }">
        <!-- See More Button -->
        <div class="text-center see-more-container">
          <button
            @click="showEpisodes = !showEpisodes"
            class="see-more-btn animate fadeInUp"
          >
            {{ showEpisodes ? "Show less" : "Show more" }}
          </button>
        </div>

        <!-- Episodes Container with Transition -->
        <transition
          name="height-expand"
          @before-enter="beforeEnter"
          @enter="enter"
          @before-leave="beforeLeave"
          @leave="leave"
        >
          <div v-if="showEpisodes" class="episodes-container">
            <!-- All episodes displayed using unified v-for loop with alternating layouts -->
            <template v-for="(episode, index) in episodes" :key="episode.id">
              <div class="film-title-container">
                <div class="circleNumber episode-circle">{{ episode.id }}</div>
                <div class="episode-number animate fadeInDown grey">
                  Episode {{ episode.id }}
                </div>
                <h3 class="film-title episode-title serif animate fadeInDown">
                  <span class="brush-title">{{ episode.title }}</span>
                </h3>
              </div>
              <div
                class="story-section animate fadeIn episode-section"
                :class="[
                  index % 2 === 0 ? 'story-right' : 'story-left',
                  index === episodes.length - 1 ? 'last-episode' : '',
                ]"
                data-theme-group="patricia"
              >
                <div class="story-content">
                  <template v-if="Array.isArray(episode.fullText)">
                    <p
                      v-for="(paragraph, pIndex) in episode.fullText"
                      :key="pIndex"
                      :class="
                        index % 2 === 0
                          ? `animate fadeInLeft delay-${pIndex + 1}`
                          : `animate fadeInRight delay-${pIndex + 1}`
                      "
                    >
                      {{ paragraph }}
                    </p>
                  </template>
                  <p
                    v-else
                    :class="
                      index % 2 === 0
                        ? 'animate fadeInLeft delay-1'
                        : 'animate fadeInRight delay-1'
                    "
                  >
                    {{ episode.fullText }}
                  </p>

                  <div
                    :class="
                      index % 2 === 0
                        ? 'film-details animate fadeInLeft delay-2'
                        : 'film-details animate fadeInRight delay-2'
                    "
                  >
                    <div class="detail-section">
                      <h4>Keywords</h4>
                      <p>
                        <span
                          v-for="keyword in episode.keywords"
                          :key="keyword"
                          >{{ keyword }}</span
                        >
                      </p>
                    </div>

                    <div class="detail-section">
                      <h4>Visual References</h4>
                      <p>{{ episode.visualReferences }}</p>
                    </div>
                  </div>
                </div>
                <div class="story-images">
                  <div :class="`episode${episode.id}-gallery`">
                    <img
                      v-for="(img, imgIndex) in episode.images"
                      :key="imgIndex"
                      :src="img"
                      :alt="`Episode ${episode.id} Scene ${imgIndex + 1}`"
                      class="animate zoomIn"
                    />
                  </div>
                </div>
              </div>
            </template>

            <!-- Show Less Button at the end -->
            <div class="text-center see-more-container">
              <button
                @click="hideEpisodesAndScroll"
                class="see-more-btn animate fadeInUp"
              >
                Show less
              </button>
            </div>
          </div>
        </transition>
      </div>
      <!-- Story 3 with right-aligned images on desktop -->
      <div class="film-title-container">
        <div class="circleNumber">3</div>

        <img
          src="@/assets/images/Patricia/images/titles/Echo.png"
          alt="Sounds of Echo"
          class="film-title film-title-echo animate fadeInDown"
        />
      </div>
      <section
        class="story-section story-right animate fadeIn"
        data-theme-group="patricia"
      >
        <div class="story-content">
          <p class="animate fadeInLeft delay-1">
            The third collection explores the concept of Echo through a feature
            film mockumentary format. This collection delves into the
            reverberations of Patricia's creative work and how her stories echo
            through different dimensions of reality and consciousness.
          </p>
        </div>
        <div class="story-images">
          <div class="film3-gallery">
            <img
              v-for="(img, index) in film3Images"
              :key="index"
              :src="img"
              :alt="`Echo Scene ${index + 1}`"
              class="animate zoomIn"
            />
          </div>
        </div>
        <div class="film-quote-container">
          <div class="film-quote film-quote-echo animate fadeIn delay-1">
            What echoes back reveals what was sent forth
          </div>
        </div>
      </section>

      <!-- Story 4 with left-aligned images on desktop -->
      <div class="film-title-container">
        <div class="circleNumber">4</div>

        <img
          :src="whatTakesShapeTitle"
          alt="What Takes Shape in the Middle of Nowhere"
          class="film-title film-title-nowhere animate fadeInDown"
        />
      </div>
      <section
        class="story-section story-left animate fadeIn"
        data-theme-group="patricia"
      >
        <div class="story-content">
          <p class="animate fadeInRight delay-1">
            The fourth and final collection explores the concept of creation
            emerging from emptiness, from the void, from the middle of nowhere.
            This feature film examines how Patricia's journey comes full circle
            as she discovers what takes shape when all external references are
            stripped away.
          </p>
        </div>
        <div class="story-images">
          <div class="film4-gallery">
            <img
              v-for="(img, index) in film4Images"
              :key="index"
              :src="img"
              :alt="`What Takes Shape Scene ${index + 1}`"
              class="animate zoomIn"
            />
          </div>
        </div>
        <div class="film-quote-container">
          <div class="film-quote film-quote-nowhere animate fadeIn delay-1">
            In the void, everything becomes possible
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { defineComponent, onMounted, ref, watch } from "vue";
import SwissStyleTable from "@/components/GenericComponents/SwissStyleTable.vue";
import useDynamicBackground from "@/composables/useDynamicBackground";
import episodes from "@/data/patriciaEpisodes.js";
import MicroNDA from "@/components/GenericComponents/MicroNDA.vue";

export default defineComponent({
  name: "PatriciaCharacter",
  components: {
    SwissStyleTable,
    MicroNDA,
  },
  setup() {
    // Episodes toggle state
    const showEpisodes = ref(false);

    // Auto-scroll when clicking "Show less" at bottom
    const hideEpisodesAndScroll = () => {
      showEpisodes.value = false;

      // Scroll to episodes header after a short delay to let transition start
      setTimeout(() => {
        const episodesHeader = document.querySelector(".the13Episodes");
        if (episodesHeader) {
          episodesHeader.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }
      }, 100);
    };

    // Use teal variant image (assuming it exists, will use placeholder path)
    const patriciaTealImage = require("@/assets/images/barbara_3_teal.png");
    // Fourth season title image
    const whatTakesShapeTitle = require("@/assets/images/Patricia/images/titles/what_takes_shape.png");

    const images = [
      require("@/assets/images/Patricia/images/patricia_00.jpg"),
      require("@/assets/images/Patricia/images/patricia_01.jpg"),
      require("@/assets/images/Patricia/images/patricia_02.jpg"),
      require("@/assets/images/Patricia/images/patricia_03.jpg"),
      require("@/assets/images/Patricia/images/patricia_04.jpg"),
      require("@/assets/images/Patricia/images/patricia_05.jpg"),
      require("@/assets/images/Patricia/images/patricia_06.jpg"),
    ];

    // Film 1 images - using all images from 1-mountain folder
    const film1Images = [
      require("@/assets/images/Patricia/images/1-mountain/1.jpg"),
      require("@/assets/images/Patricia/images/1-mountain/2.jpg"),
      require("@/assets/images/Patricia/images/1-mountain/3.jpg"),
      require("@/assets/images/Patricia/images/1-mountain/4.jpg"),
      require("@/assets/images/Patricia/images/1-mountain/5.jpg"),
      require("@/assets/images/Patricia/images/1-mountain/6.jpg"),
      require("@/assets/images/Patricia/images/1-mountain/7.jpg"),
      require("@/assets/images/Patricia/images/1-mountain/8.jpg"),
      require("@/assets/images/Patricia/images/1-mountain/9.jpg"),
      require("@/assets/images/Patricia/images/1-mountain/10.jpg"),
      require("@/assets/images/Patricia/images/1-mountain/11.jpg"),
      require("@/assets/images/Patricia/images/1-mountain/12.jpg"),
      require("@/assets/images/Patricia/images/1-mountain/13.jpg"),
      require("@/assets/images/Patricia/images/1-mountain/14.jpg"),
      require("@/assets/images/Patricia/images/1-mountain/15.jpg"),
      require("@/assets/images/Patricia/images/1-mountain/16.jpg"),
      require("@/assets/images/Patricia/images/1-mountain/17.jpg"),
      require("@/assets/images/Patricia/images/1-mountain/18.jpg"),
      require("@/assets/images/Patricia/images/1-mountain/19.jpg"),
      require("@/assets/images/Patricia/images/1-mountain/20.jpg"),
      require("@/assets/images/Patricia/images/1-mountain/21.jpg"),
      require("@/assets/images/Patricia/images/1-mountain/22.jpg"),
      require("@/assets/images/Patricia/images/1-mountain/23.jpg"),
      require("@/assets/images/Patricia/images/1-mountain/24.jpg"),
      require("@/assets/images/Patricia/images/1-mountain/25.jpg"),
      require("@/assets/images/Patricia/images/1-mountain/26.jpg"),
      require("@/assets/images/Patricia/images/1-mountain/27.jpg"),
      require("@/assets/images/Patricia/images/1-mountain/28.jpg"),
      require("@/assets/images/Patricia/images/1-mountain/29.jpg"),
    ];

    // Film 2 images - using all images from 2-man folder
    const film2Images = [
      require("@/assets/images/Patricia/images/2-man/0.jpg"),
      require("@/assets/images/Patricia/images/2-man/1.jpg"),
      require("@/assets/images/Patricia/images/2-man/2.jpg"),
      require("@/assets/images/Patricia/images/2-man/3.jpg"),
      require("@/assets/images/Patricia/images/2-man/4.jpg"),
      require("@/assets/images/Patricia/images/2-man/5.jpg"),
      require("@/assets/images/Patricia/images/2-man/6.jpg"),
      require("@/assets/images/Patricia/images/2-man/7.jpg"),
      require("@/assets/images/Patricia/images/2-man/8.jpg"),
      require("@/assets/images/Patricia/images/2-man/9.jpg"),
      require("@/assets/images/Patricia/images/2-man/10.jpg"),
      require("@/assets/images/Patricia/images/2-man/11.jpg"),
      require("@/assets/images/Patricia/images/2-man/12.jpg"),
      require("@/assets/images/Patricia/images/2-man/13.jpg"),
      require("@/assets/images/Patricia/images/2-man/14.jpg"),
      require("@/assets/images/Patricia/images/2-man/15.jpg"),
      require("@/assets/images/Patricia/images/2-man/16.jpg"),
      require("@/assets/images/Patricia/images/2-man/17.jpg"),
      require("@/assets/images/Patricia/images/2-man/18.jpg"),
      require("@/assets/images/Patricia/images/2-man/19.jpg"),
      require("@/assets/images/Patricia/images/2-man/20.jpg"),
      require("@/assets/images/Patricia/images/2-man/21.jpg"),
      require("@/assets/images/Patricia/images/2-man/22.jpg"),
    ];

    // Film 3 & 4 images - using 3 repeated placeholders
    const film3Images = [
      require("@/assets/images/Patricia/images/patricia_00.jpg"),
      require("@/assets/images/Patricia/images/patricia_01.jpg"),
      require("@/assets/images/Patricia/images/patricia_02.jpg"),
    ];

    const film4Images = [
      require("@/assets/images/Patricia/images/patricia_00.jpg"),
      require("@/assets/images/Patricia/images/patricia_01.jpg"),
      require("@/assets/images/Patricia/images/patricia_02.jpg"),
    ];

    // Use the dynamic background composable
    const { currentVisibleSection, currentBodyClasses } =
      useDynamicBackground();

    // Store observer instance for reuse in transition hooks
    let observerInstance = null;

    // Setup intersection observer (reusable function)
    const setupIntersectionObserver = () => {
      const observerOptions = {
        root: null,
        rootMargin: "0px 0px 0px 0px",
        threshold: 0.01,
      };

      const handleIntersection = (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("active");
          } else {
            entry.target.classList.remove("active");
          }
        });
      };

      observerInstance = new IntersectionObserver(
        handleIntersection,
        observerOptions
      );

      // Observe all existing animate elements
      const elements = document.querySelectorAll(".animate");
      elements.forEach((el) => {
        if (el) observerInstance.observe(el);
      });
    };

    // Transition hook methods for height animation
    const beforeEnter = (el) => {
      el.style.height = "0";
      el.style.overflow = "hidden";
      el.style.transition = "height 0.4s ease";
    };

    const enter = (el) => {
      // Trigger reflow to apply initial styles
      el.offsetHeight;

      // Wait for images to load before calculating height
      const images = el.querySelectorAll("img");
      let loadedImages = 0;
      const totalImages = images.length;

      const checkHeight = () => {
        // Set height to actual content height
        el.style.height = el.scrollHeight + "px";

        // Re-observe new episode elements after height is set
        setTimeout(() => {
          if (observerInstance) {
            const newElements = el.querySelectorAll(".animate");
            newElements.forEach((element) => {
              if (element) observerInstance.observe(element);
            });
          }
        }, 100);
      };

      if (totalImages === 0) {
        // No images, calculate height immediately
        checkHeight();
      } else {
        // Wait for images to load
        images.forEach((img) => {
          if (img.complete) {
            loadedImages++;
          } else {
            img.onload = () => {
              loadedImages++;
              if (loadedImages === totalImages) {
                checkHeight();
              }
            };
            img.onerror = () => {
              loadedImages++;
              if (loadedImages === totalImages) {
                checkHeight();
              }
            };
          }
        });

        // Fallback: if images take too long, calculate height anyway
        setTimeout(() => {
          if (loadedImages < totalImages) {
            checkHeight();
          }
        }, 1000);

        // Initial height calculation in case images are cached
        if (loadedImages === totalImages) {
          checkHeight();
        }
      }
    };

    const beforeLeave = (el) => {
      el.style.height = el.scrollHeight + "px";
      el.style.overflow = "hidden";
      el.style.transition = "height 0.4s ease";
    };

    const leave = (el) => {
      // Trigger reflow
      el.offsetHeight;
      // Animate to 0 height
      el.style.height = "0";
    };

    // Watch for episodes expansion to force light theme
    watch(showEpisodes, (newValue) => {
      if (newValue === true) {
        // Only dispatch when showing episodes
        const event = new CustomEvent("episodesExpanded", {
          detail: { themeGroup: "patricia" },
        });
        window.dispatchEvent(event);
      }
    });

    onMounted(() => {
      // Setup intersection observer
      setupIntersectionObserver();

      // Listen for theme changes globally (same as Cecilia)
      window.addEventListener("themeChange", (event) => {
        setTimeout(() => {
          const drawer = document.querySelector(".BottomDrawer");
          if (drawer) {
            if (event.detail.isLightTheme) {
              drawer.classList.add("light-theme");
            } else {
              drawer.classList.remove("light-theme");
            }
          }
        }, 100);
      });
    });

    return {
      patriciaTealImage,
      whatTakesShapeTitle,
      images,
      film1Images,
      film2Images,
      film3Images,
      film4Images,
      episodes,
      currentVisibleSection,
      currentBodyClasses,
      showEpisodes,
      hideEpisodesAndScroll,
      beforeEnter,
      enter,
      beforeLeave,
      leave,
    };
  },
});
</script>

<style scoped>
/* Sanguine font for Man season episode titles */
@font-face {
  font-family: "Sanguine";
  src: url("../../assets/fonts/Sanguine/Web Fonts/e884eee22ace3abf97b98d248598bc43.woff2")
      format("woff2"),
    url("../../assets/fonts/Sanguine/Web Fonts/e884eee22ace3abf97b98d248598bc43.woff")
      format("woff"),
    url("../../assets/fonts/Sanguine/Web Fonts/e884eee22ace3abf97b98d248598bc43.ttf")
      format("truetype"),
    url("../../assets/fonts/Sanguine/Web Fonts/e884eee22ace3abf97b98d248598bc43.eot")
      format("embedded-opentype"),
    url("../../assets/fonts/Sanguine/Web Fonts/e884eee22ace3abf97b98d248598bc43.svg#Sanguine")
      format("svg");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

/* YDWinterB font for Man season episode titles */
@font-face {
  font-family: "YDWinterB";
  src: url("../../assets/fonts/YDWinterB/b35973b05a367517d70edf7b82d68f52.woff2")
      format("woff2"),
    url("../../assets/fonts/YDWinterB/b35973b05a367517d70edf7b82d68f52.woff")
      format("woff"),
    url("../../assets/fonts/YDWinterB/b35973b05a367517d70edf7b82d68f52.ttf")
      format("truetype"),
    url("../../assets/fonts/YDWinterB/b35973b05a367517d70edf7b82d68f52.eot")
      format("embedded-opentype"),
    url("../../assets/fonts/YDWinterB/b35973b05a367517d70edf7b82d68f52.svg#YDWinterB")
      format("svg");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

/* BlippoBlack font (use woff2/woff, avoid otf) */
@font-face {
  font-family: "BlippoBlack";
  src: url("../../assets/fonts/BlippoBlack/BlippoBT-Black.woff2")
      format("woff2"),
    url("../../assets/fonts/BlippoBlack/BlippoBT-Black.woff") format("woff");
  font-weight: 900;
  font-style: normal;
  font-display: swap;
}

/* Hollywood font for final quote (use woff2/woff) */
@font-face {
  font-family: "Hollywood";
  src: url("../../assets/fonts/SF_Hollywood/SFHollywoodHills-Bold.woff2")
      format("woff2"),
    url("../../assets/fonts/SF_Hollywood/SFHollywoodHills-Bold.woff")
      format("woff");
  font-weight: 700;
  font-style: normal;
  font-display: swap;
}

/* Man season episode titles */
.episodes-container .episode-title {
  font-family: "YDWinterB", serif;
  color: #e4b872;
  text-shadow: 2px 2px 0 #ac0001;
  transform: skewY(-3deg);
}

/* Brush background behind episode titles (handles multi-line) */
.episodes-container .episode-title .brush-title {
  background-image: url("@/assets/images/brush-light.svg");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center;
  padding: 0.2em 0.35em; /* breathing room inside brush */
  line-height: 1.1;
  display: inline;
  box-decoration-break: clone; /* allows background to wrap cleanly */
  -webkit-box-decoration-break: clone;
  letter-spacing: -2px;
}

/* Base styles - inherit most from Cecilia with Patricia-specific tweaks */
.patricia-container {
  max-width: 900px;
  margin: 0 auto;
  overflow-x: hidden;
  box-sizing: border-box;
  padding: var(--space) 0;
  width: 100%;
}

.headerImgText {
  max-height: 260px;
}

.headerQuote {
  width: 100%;
  align-items: flex-start !important;
  position: relative;
  height: 110px;
}
.fromPatricia {
  position: absolute;
  top: 0;
  left: 0;
  white-space: nowrap;
}
.toAlterEgos {
  position: absolute;
  left: -70px;
  white-space: nowrap;
  bottom: 0;
}
.untold {
  position: absolute;
  white-space: nowrap;
  bottom: -50px;
  right: 20px;
}

.portrait-image-container {
  position: relative;
  width: 100%;
  height: 60vh;
  max-height: 400px;
  margin: var(--doubleSpace) auto;
  overflow: visible;
}

.patriciaTealImage {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
  width: auto;
  height: 100%; /* Fill container height */
  object-fit: contain; /* Maintain aspect ratio */
  border-radius: var(--border-radius-medium);
  transition: opacity 0.3s ease;
}

/* Special title styling for "Man Shall Never Know Any Of This" */
.film-title-manshall {
  font-size: calc(var(--largerFontSize) * 2.5);
  line-height: 1.2;
  text-align: center;
}

.manshall-man {
  font-family: "RockSalt", "AlternateGotNo2D", sans-serif;
  font-weight: bold;
  font-size: calc(var(--largerFontSize) * 3);
}

.manshall-never {
  font-family: "BespokeSerif", serif;
  font-size: calc(var(--largerFontSize) * 1.8);
  font-weight: 300;
  letter-spacing: -0.5px;
  text-transform: lowercase;
}

.manshall-this {
  font-family: "BespokeSerif", serif;
  font-size: calc(var(--largerFontSize) * 1.8);
  letter-spacing: 0.5em;
  text-transform: lowercase;
}

.the13Episodes {
  text-align: center;
  margin-top: calc(var(--doubleSpace) * 2);
  width: 100%;
}

/* Hide episode circle numbers while keeping background */
.circleNumber.episode-circle {
  position: absolute;
  opacity: 0;
}

.episode-number {
  text-transform: uppercase;
  letter-spacing: 3px;
  font-size: calc(var(--smallFontSize) * 0.8);
  border-top: 1px solid var(--border-light);
  padding: 30px;
}

/* Episodes section styling */
.episodes-section {
  margin: var(--doubleSpace) 0;
  padding: var(--doubleSpace) 0;
  border-top: 1px solid var(--border-light);
}

/* Film quote styling */
.film-quote {
  margin: 0 auto;
  padding: var(--space);
  position: relative;
  border-left: none;
  padding: var(--doubleSpace) var(--space);
  width: 100%;
  text-align: center;
  box-sizing: border-box;
  font-size: calc(var(--regularFontSize) * 2.5);
}

.film-quote-mountain {
  font-family: "RockSalt", "AlternateGotNo2D", sans-serif;
  text-align: center;
  font-style: normal;
  font-weight: bold;
}

.film-quote-manshall {
  font-family: "Core Sans", sans-serif;
  font-weight: 600;
}

.film-quote-echo {
  font-family: "BlippoBlack", "Inter", sans-serif;
  font-weight: 900;
  /* color: #ec7a4c; */
}

.film-quote-nowhere {
  font-family: "Hollywood", sans-serif;
  font-weight: 700;
  /* Thin outline in #fff200; keep fill transparent so only outline shows */
  /* color: #000;
  -webkit-text-stroke: 1px #fff200;
  text-shadow: 1px 0 0 #fff200, -1px 0 0 #fff200, 0 1px 0 #fff200,
    0 -1px 0 #fff200; */
}

/* Inherit all other styles from Cecilia */
.intro-text {
  font-size: var(--smallFontSize);
  line-height: 1.4;
  margin-bottom: calc(var(--space) * 6.5);
}
.intro-text::after {
  content: "";
  position: absolute;
  top: calc(var(--regularFontSize) * 2);
  left: 50%;
  transform: translateX(-50%);
  width: 50px;
  height: 1px;
  background: var(--text-white);
}

.largest-TextMag {
  font-size: calc(var(--giganticFontSize) * 1.2) !important;
  font-weight: 630;
}

img {
  max-width: 100%;
  height: auto;
  border-radius: var(--border-radius-medium);
}

/* Story section layouts - same as Cecilia */
.story-section {
  margin-bottom: var(--doubleSpace);
  display: flex;
  flex-direction: column;
  gap: var(--space);
  max-width: 100%;
  box-sizing: border-box;
}

.film-title-container {
  width: 100%;
  max-width: 900px;
  margin: calc(var(--doubleSpace) * 4) auto var(--doubleSpace) auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.film-title {
  width: 100%;
  margin: var(--space) 0 var(--doubleSpace) 0;
  text-align: center;
  font-size: calc(var(--largerFontSize) * 1.8) !important;
}

img.film-title-mountain {
  width: 60%;
  max-width: 220px;
  height: auto;
  object-fit: cover;
  border-radius: var(--border-radius-medium);
}
img.film-title-man {
  width: 60%;
  max-width: 400px;
  height: auto;
  object-fit: cover;
  border-radius: var(--border-radius-medium);
}

img.film-title-echo {
  width: 60%;
  max-width: 300px;
  height: auto;
  object-fit: cover;
  border-radius: var(--border-radius-medium);
}

img.film-title-nowhere {
  width: 80%;
  max-width: 400px;
  height: auto;
  object-fit: cover;
  border-radius: var(--border-radius-medium);
}

/* Film galleries */
.film1-gallery,
.film2-gallery,
.film3-gallery,
.film4-gallery,
.episode1-gallery,
.episode2-gallery,
.episode3-gallery,
.episode4-gallery,
.episode5-gallery,
.episode6-gallery,
.episode7-gallery,
.episode8-gallery,
.episode9-gallery,
.episode10-gallery,
.episode11-gallery,
.episode12-gallery,
.episode13-gallery {
  display: flex;
  flex-direction: column;
  gap: var(--space);
  margin-top: var(--space);
}

.film1-gallery img,
.film2-gallery img,
.film3-gallery img,
.film4-gallery img,
.episode1-gallery img,
.episode2-gallery img,
.episode3-gallery img,
.episode4-gallery img,
.episode5-gallery img,
.episode6-gallery img,
.episode7-gallery img,
.episode8-gallery img,
.episode9-gallery img,
.episode10-gallery img,
.episode11-gallery img,
.episode12-gallery img,
.episode13-gallery img {
  display: block;
  width: 100%;
  height: auto;
  object-fit: cover;
  border-radius: var(--border-radius-medium);
}

.last-episode {
  padding-bottom: calc(var(--doubleSpace) * 2);
  border-bottom: 1px solid var(--border-dark);
}

/* Generic animation rule for all images in story sections (excludes about section) */
.story-images img.animate {
  transition: opacity 0.25s ease, transform 0.25s ease;
  opacity: 0;
  transform: scale(0.95);
}

.story-images img.animate.active {
  opacity: 1;
  transform: scale(1);
}

/* Detail sections */
.detail-section {
  margin-bottom: var(--space);
  margin-top: var(--bigSpace);
}

.detail-section h4 {
  font-size: var(--smallFontSize);
  color: var(--text-white);
  margin-bottom: var(--smallSpace);
  text-transform: uppercase;
  letter-spacing: 0.25em;
  font-weight: 250;
  opacity: 1;
}

.detail-section p {
  font-size: var(--smallFontSize);
  color: var(--grey-lighter);
  line-height: 1.6;
}

.detail-section:first-child p {
  display: flex;
  flex-wrap: wrap;
  gap: var(--smallSpace);
}

.detail-section:first-child p span {
  display: inline-block;
  background-color: rgba(255, 255, 255, 0.1);
  color: var(--text-white);
  padding: 2px 8px;
  border: 1px solid var(--text-white);
  border-radius: var(--border-radius-pill);
  font-size: calc(var(--smallFontSize) * 0.9);
  font-weight: 220;
  margin-bottom: var(--smallSpace);
}

/* Light theme overrides for keywords and section titles */
body.light-theme .detail-section h4 {
  color: var(--text-light);
}

body.light-theme .detail-section:first-child p span {
  color: var(--text-light);
  border-color: var(--text-light);
}

body.light-theme .detail-section p {
  color: var(--text-light);
}

/* About section */
.about-content {
  display: flex;
  flex-direction: column;
  gap: var(--space);
}

.about-text {
  flex: 1;
}

.about-images {
  display: flex;
  flex-direction: column;
  gap: var(--space);
}
.border-bottom {
  padding-bottom: calc(var(--doubleSpace) * 3);

  border-bottom: 1px solid var(--border-dark);
}

/* Responsive design */
/* bigger screens */
@media (min-width: 768px) {
  .patricia-container {
    padding: 0 var(--largeSpace);
    max-width: 900px;
    overflow: hidden;
    box-sizing: border-box;
  }

  .about-content {
    flex-direction: row;
    align-items: flex-start;
  }

  .about-images {
    width: 40%;
  }

  .story-section {
    display: grid;
    grid-template-columns: 62% 34%;
    align-items: flex-start;
    gap: var(--doubleSpace);
    width: 100%;
    max-width: 100%;
    margin: 0 auto;
    justify-content: space-between;
    box-sizing: border-box;
  }

  .story-section.story-right {
    grid-template-areas: "content images";
  }

  .story-section.story-left {
    grid-template-areas: "images content";
    grid-template-columns: 34% 62%;
  }

  .story-section.story-right .story-content {
    grid-area: content;
  }

  .story-section.story-right .story-images {
    grid-area: images;
  }

  .story-section.story-left .story-content {
    grid-area: content;
  }

  .story-section.story-left .story-images {
    grid-area: images;
  }

  /* Film quote container spans both columns in grid */
  .film-quote-container {
    grid-column: 1 / -1;
    width: 100%;
    text-align: center;
    margin: var(--doubleSpace) auto;
  }

  .episodes-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

/* Mobile styles */
@media (max-width: 767px) {
  .largest-TextMag {
    font-size: calc(var(--giganticFontSize) * 0.9) !important;
  }

  .portrait-image-container {
    height: 30vh;
    max-height: 200px;
  }

  /* .intro-section {
    max-width: 400px;
  } */

  /* .about-section {
    width: 100%;
  } */

  .fromPatricia {
    top: 6px;
    left: -60%;
    font-size: 0.9em;
  }
  .toAlterEgos {
    left: -105%;
    bottom: 0;
    font-size: 0.8em;
  }
  .untold {
    bottom: -50px;
    right: 0px;
  }

  .fromPatricia h2,
  .toAlterEgos h2,
  .untold h2 {
    font-size: var(--largerFontSize) !important;
  }
  /* On mobile, ensure text comes before images in all story sections */
  .story-section.story-left {
    display: flex;
    flex-direction: column;
  }

  .story-section.story-left .story-content {
    order: 1;
  }

  .story-section.story-left .story-images {
    order: 2;
  }

  .story-section > .film-quote-container {
    order: 3;
  }

  /* Film quote container styling */
  .film-quote-container {
    width: 100%;
    margin: var(--doubleSpace) auto;
    text-align: center;
    grid-column: 1 / -1;
    box-sizing: border-box;
  }

  /* Film title styling */
  .film-title-container {
    margin: calc(var(--doubleSpace) * 3) auto var(--largeSpace) auto;
    text-align: center;
  }

  .film-title {
    margin: var(--space) 0 var(--space) 0;
    font-size: calc(var(--largerFontSize) * 1.9) !important;
  }

  .manshall-man {
    font-size: calc(var(--largerFontSize) * 2);
  }

  .manshall-never,
  .manshall-this {
    font-size: calc(var(--largerFontSize) * 1.4);
  }

  .film-quote {
    font-size: calc(var(--regularFontSize) * 2.5);
  }

  .episodes-grid {
    grid-template-columns: 1fr;
  }

  /* Keep animations within visible boundaries on mobile */
  .animate {
    opacity: 0;
    transition: opacity 0.3s ease;
  }
  .animate.active {
    opacity: 1;
  }
}

/* See More Button Styling */
.see-more-container {
  margin: var(--doubleSpace) 0;
}

.see-more-btn {
  height: var(--clickableHeight);
  border-radius: var(--border-radius-pill);
  border: 1px solid var(--text-white);
  background-color: transparent;
  color: var(--text-white);
  outline: none;
  cursor: pointer;
  transition: all var(--fastSpeed) ease;
  font-family: "Inter", system-ui, sans-serif;
  font-weight: 250;
  font-size: var(--regularFontSize);
  padding: var(--largeSpace);
  text-align: center;
  display: inline-flex;
  gap: var(--smallSpace);
  align-items: center;
}

.see-more-btn:hover {
  background-color: var(--grey-darkest);
}

/* Light theme button styling */
body.light-theme .see-more-btn {
  border-color: var(--text-light);
  color: var(--text-light);
}

body.light-theme .see-more-btn:hover {
  background-color: var(--grey-lighter);
}

.episodes-container {
  margin-top: var(--largeSpace);
}
</style>
